<section class="apc">
  <div class="apc-head">
    <strong>Your saved preferences</strong>
    <button type="button" class="apc-edit" (click)="edit.emit()">Edit</button>
  </div>
  <p class="apc-muted">Your feed, recommendations and {{ agentName || 'your agent' }} reflect these interests.</p>
  <div class="apc-list" *ngIf="preferences?.length; else empty">
    <span class="apc-pref" *ngFor="let pref of preferences">{{ pref }}</span>
  </div>
  <ng-template #empty><p class="apc-muted apc-empty">No preferences saved yet.</p></ng-template>
</section>
